<template>
<div class="home">
  <div class="app-view">
    <AppSidebar/>
    <div class="main-body">
      <div class="container-fluid">
        <!-- Added key in order to re-render component when some part of route is changed,
             and when the language changes, so the page loads its data again in the new language (US 9372) -->
        <router-view :key="$route.fullPath + '|' + $i18n.locale"/>
      </div>
    </div>
    <!-- <div class="task-toolbar-switch card"
         @click="toggleToolbar"
         v-if="getClient.projectModule"
    >
      <font-awesome-icon icon="list-ul"/>
    </div> -->
    <!-- <div class="help-center-switch card" @click="toggleHelpCenter">
      <font-awesome-icon icon="book-open"/>
    </div> -->

    <!-- <div v-if="getHelpCenterState">
      <GuideNavigation></GuideNavigation>
    </div> -->

  </div>
</div>
</template>

<script>
// @ is an alias to /src
import AppSidebar from '@/components/navigation/AppSidebar.vue'
import GuideNavigation from '@/components/guide/GuideNavigation.vue'


export default {
  name: 'AppContainer',
  components: {
    AppSidebar,
    GuideNavigation
  },
  watch: {
    // getActiveTaskObject: function (newValue, oldValue) {
    //   let self = this;
    //   if (newValue && oldValue && newValue.id && oldValue.id) {
    //     let helpCenterState = true
    //     let topElement = document.getElementById("app");
    //
    //     // Update top level class to collapsed only if main navigation
    //     this.$store.commit('storeHelpCenterState', helpCenterState);
    //
    //     if (topElement.classList.contains("guide-collapsed")) {
    //       topElement.classList.toggle("guide-collapsed");
    //     }
    //     if (!topElement.classList.contains("activity-collapsed")) {
    //       topElement.classList.toggle("activity-collapsed");
    //       this.$store.commit('storeHelpCenterState', true);
    //     }
    //   }
    // }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getTaskToolbarState() {
      return this.$store.state.taskToolbarState
    },
    getHelpCenterState() {
      return this.$store.state.helpCenterState
    },
    getActiveTaskObject() {
      return this.$store.state.activeTaskObject
    },
    getNavType() {
      return this.$store.state.activeNavbar
    },
  },
  methods:{
    toggleToolbar() {
      let toolbarState = this.getTaskToolbarState ? false : true
      this.$store.commit('storeTaskToolbarState', toolbarState);
      if (!toolbarState) {
        this.$store.commit('storeActiveTask', {});
        this.$store.commit('storeActiveTaskPosition', 0);
      }
    },
    toggleHelpCenter() {
      let helpCenterState = this.getHelpCenterState ? false : true
      let topElement = document.getElementById("app");

      // Update top level class to collapsed only if main navigation
      this.$store.commit('storeHelpCenterState', helpCenterState);
      topElement.classList.toggle("guide-collapsed");
      if (!topElement.classList.contains("activity-collapsed")) {
        topElement.classList.toggle("activity-collapsed");
        this.$store.commit('storeHelpCenterState', true);
      }

      if (!helpCenterState) {
        this.$store.commit('storeActiveGuideScope', {});
      }
    }
  }
}
</script>
